import { Outlet } from 'react-router-dom';
import Logo from '../components/common/logo.jsx';
/**
 * Auth Layout Component
 * Minimal layout for authentication pages
 */
const AuthLayout = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-primary-50 to-secondary-100 px-4 py-12">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <Logo className="mx-auto h-12 w-auto" />
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
